import { render, staticRenderFns } from "./createTransactionPayment.vue?vue&type=template&id=08b5f49b"
import script from "./createTransactionPayment.vue?vue&type=script&lang=js"
export * from "./createTransactionPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports